import isBrowser from './isBrowser';
import serverConfig from '../serverConfig';

/**
 * get host for internal requests
 */
export const getHost = () => (isBrowser() ? location.origin : serverConfig.ENTERPRISE_HOST);
